// UpcomingAdmissions.jsx
import styles from "./UpcomingAdmissions.module.css";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import { FiEdit2 } from "react-icons/fi";
import { HiOutlineDocumentText } from "react-icons/hi2";

const colorPresets = [
  { rgb: "39, 174, 96" }, // --Success_Color
  { rgb: "192, 57, 43" }, // --Error_Color
  { rgb: "230, 126, 34" }, // --Warning_Color
  { rgb: "41, 128, 185" }, // --Info_Color
];


const admissionData = [
  {
    name: "John Steeve",
    age: "03 yrs",
    className: "Class 3A",
  },
  {
    name: "John Steeve",
    age: "03 yrs",
    className: "Class 3A",
  },
  {
    name: "John Steeve",
    age: "03 yrs",
    className: "Class 3A",
  },
];

const UpcomingAdmissions = () => {
  const cards = admissionData.map((item) => {
    const random =
      colorPresets[Math.floor(Math.random() * colorPresets.length)];
    return {
      ...item,
      bgColor: `rgba(${random.rgb}, 0.35)`,
      textColor: `rgb(${random.rgb})`,
      circleBgColor: `rgb(${random.rgb})`,
      circleTextColor: "#ffffff",
    };
  });

  const handleViewAll = () => {
    console.log("View All Upcoming Admissions clicked");
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerRow}>
        <HeadingAndIcon
          icon={<HiOutlineDocumentText />}
          heading="Upcoming Admissions"
        />
        <div className={styles.editWrapper}>
          <FiEdit2 size={16} /> <span>This Month</span>
        </div>
      </div>

      <div className={styles.list}>
        {cards.map((item, i) => (
          <div
            key={i}
            className={styles.dataCard}
            style={{ backgroundColor: item.bgColor }}
          >
            <LogoWithName
              name={item.name}
              subLabel={`Age : ${item.age}`}
              color={item.textColor}
              bgColor={item.circleBgColor}
              circleTextColor={item.circleTextColor}
            />
            <span
              className={styles.classLabel}
              style={{ color: item.textColor }}
            >
              {item.className}
            </span>
          </div>
        ))}
      </div>

      <div className={styles.footer}>
        <span className={styles.viewAll} onClick={handleViewAll}>
          View All
        </span>
      </div>
    </div>
  );
};

export default UpcomingAdmissions;
